import { SectionCallType } from "../SectionCallType";
import { SectionCallUuid } from "../SectionCallUuid";
import { SectionNumber } from "../SectionNumber/SectionNumber";
import { SectionParticipants } from "../SectionParticipants/SectionParticipants";
import { SectionTags } from "../SectionTags";
import { SectionTiming } from "../SectionTiming";

export function CallSection() {
  return (
    <div className="flex flex-col gap-6" data-test="call-section">
      <SectionTags />
      <SectionCallType />
      <SectionTiming />
      <SectionParticipants />
      <SectionNumber />
      <SectionCallUuid />
    </div>
  );
}
